import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutosuggestPopupComponent } from './autosuggest-popup/autosuggest-popup.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, FormsModule],
  declarations: [AutosuggestPopupComponent],
  exports: [AutosuggestPopupComponent]
})
export class AutosuggestPopupModule {}
